
export function filteredAgentsList(state : any, payload : any) {
    const { workers } = payload;
    const wKeys = Object.keys(workers);
    const list = wKeys.map((it : any) => workers[it]);

    return list
          .filter(filterByType.bind({}, state))
          .filter(filterByDepartment.bind({}, state))
          .filter(filterBySearch.bind({}, state))
          .filter(filterByActivity.bind({}))
          .filter(filterByReceptionSkill.bind({}))
          .sort((a, b) => (+b.attributes?.scorecard || 0) - (+a.attributes?.scorecard || 0));
}

function filterByType(state : any, listItem : any) : boolean {
    const { filters } = state;

    if ( filters.type === true ) {
        return listItem.attributes?.skills?.indexOf('dsr') < 0;
    } else if ( filters.type === false ) {
        return listItem.attributes?.skills?.indexOf('dsr') >= 0;
    }

    return true;
}

function filterBySearch(state : any, listItem : any) : boolean {
    const { filters } = state;
    const phrase = filters?.phrase || '';
    const userName = listItem.attributes?.full_name || listItem?.friendly_name || listItem.attributes?.email || '';
    return userName.toLowerCase()?.indexOf(phrase.toLowerCase()) >= 0;
}

function filterByDepartment(state : any, listItem : any) : boolean {
    const { filters } = state;
    const categories = listItem.attributes?.categories || [];
    const departmentId = filters.departmentId || -1;

    if ( departmentId >= 0) {
        return categories.findIndex((it : number) => it === departmentId) >= 0;
    }

    return true;
}

function filterByActivity(listItem : any) : boolean {
    return listItem.activity_name !== 'Offline';
}

function filterByReceptionSkill(listItem : any) : boolean {
    let skills = listItem.attributes?.skills || [];
    return skills.indexOf('reception') === -1;
}
